module.exports = __webpack_public_path__ + "img/cama-lambrusca.cc26928c.png";